import http from '@/services/http'

export const indexEstadosRequest = () => {
  return http.get('estados')
}

export const showEstadosRequest = (id) => {
  return http.get(`estados/${id}`)
}

export const showCidadesRequest = (search) => {
  return http.get('cidades', {
    params: {search:search}
  })
}